<template>
  <b-modal
    v-if="getPriceMatchModalData && Object.keys(getPriceMatchModalData).length"
    data-testid="price-match-modal"
    id="price-match-modal"
    hide-footer
    hide-header
    centered
    size="lg"
    modal-class="price-match-modal"
    @close="onClose"
  >
    <div class="price-match-modal__body">
      <button
        data-testid="button-close-modal"
        type="button"
        class="close price-match-modal__close"
        aria-label="Close"
        @click="$bvModal.hide('price-match-modal')"
      >
        <span></span>
        <span></span>
      </button>

      <img
        crossorigin="anonymous"
        itemprop="logo"
        :src="
          (getPriceMatchModalData.image && getPriceMatchModalData.image.url) ||
          'https://statics.radissonhotels.com/main/img/logo/radisson/radisson-hotels-ressorts.png'
        "
        :alt="(getPriceMatchModalData.image && getPriceMatchModalData.image.altText) || 'logo RHG'"
        class="price-match-modal__image"
        data-testid="claim-price-match-image"
      />

      <div class="price-match-modal__content">
        <i :class="`icon icon-${getPriceMatchModalData.icon} md`"></i>

        <div class="price-match-modal__text">
          <h2
            v-if="showTitle"
            class="price-match-modal__title"
            data-testid="claim-price-match-title"
          >
            {{ getPriceMatchModalData.title }}
          </h2>
          <p
            class="price-match-modal__description"
            v-html="descriptionLabel"
            data-testid="claim-price-match-description"
          />
        </div>

        <button
          class="price-match-modal__cta btn btn-primary text-uppercase"
          @click="claimPriceMatch"
          data-testid="claim-price-match-cta"
        >
          <span>{{ translate('rdPriceMatchPopUpCTA') }}</span>
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('multiRoomDisplay')

export default {
  name: 'PriceMatchModal',
  computed: {
    ...mapGetters(['getPriceMatchModalData', 'getPriceMatchData']),
    descriptionLabel() {
      const discount = this.getPriceMatchData?.discount || 0
      const desc = this.getPriceMatchModalData.description
      if (!!desc && desc.trim() !== '') {
        return desc.replace('{0}', `<strong>${discount}%</strong>`)
      } else {
        return ''
      }
    },
    showTitle() {
      const title = this.getPriceMatchModalData.title
      return !!title && title.trim() !== ''
    }
  },
  methods: {
    claimPriceMatch() {
      this.$emit('claimPriceMatch')
      this.$root.$emit('bv::hide::modal', 'price-match-modal')
    }
  }
}
</script>

<style lang="scss" scoped>
.price-match-modal {
  &__body {
    background-color: #29343d;
    height: 528px;
    display: flex;
    @media (max-width: 992px) {
      flex-direction: column;
      height: 478px;
    }
  }

  &__close {
    position: absolute;
    top: 1rem;
    right: 1rem;
    z-index: 1;
  }

  &__image {
    width: 50%;
    height: 100%;
    object-fit: cover;

    @media (max-width: 992px) {
      width: 100%;
      height: 165px;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #fff;
    gap: 2.4rem;
    margin: auto;
  }

  &__text {
    display: flex;
    flex-direction: column;
    gap: 1.6rem;
  }

  &__title {
    font-size: 3.6rem;
    line-height: 4.8rem;
    font-weight: 700;

    @media (max-width: 992px) {
      font-size: 3.2rem;
      line-height: 3.8rem;
    }
  }

  &__description {
    font-size: 1.6rem;
    line-height: 2.4rem;
    margin-bottom: 0 !important;
  }

  &__cta {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    border-radius: 48px;
    background-color: #c62525;
    @media (max-width: 992px) {
      width: 100%;
    }
    span {
      padding: 0 12px;
      font-size: 16px;
    }
  }
}
</style>
